import { useTailgateGrid } from '../hooks/useTailgateGrid'
import { useLightMode } from '@/hooks/useLightMode'
import { useTranslation } from 'react-i18next'

import { useDisclosure } from '@chakra-ui/react'

import { Box as DarkBox, Modal } from '@hivewatch/dark'

import { GTZ_ENTER } from '@/utils/analytics'

import { GridModalBody } from '../components/GridModalBody'
import { GridModalDetails } from '../components/GridModalDetails'
import { GridTestingZone } from '../grid-testing-zone/components/GridTestingZone'

// Dark twin of TailgateGridModal — chrome only. The grid canvas sizes itself
// from a fixed IMAGE_WIDTH and an SVG viewBox, so the modal shell does not
// affect grid coordinate mapping; the drawing internals are reused untouched.
export const DarkTailgateGridModal = ({ zIndex }: { zIndex?: number }) => {
  const { t } = useTranslation()
  const colorScheme = useLightMode()
  const {
    clearBoxes,
    DummyPlayer,
    resetVideoFrame,
    shouldRenderDummyPlayer,
    isTailgateGridOpen,
    onTailgateGridClose,
    trackTailgateEvent,
  } = useTailgateGrid()
  const testModalDisclosure = useDisclosure()

  const handleClose = () => {
    onTailgateGridClose()
    resetVideoFrame()
    clearBoxes()
  }

  const handleOpenTestModal = () => {
    trackTailgateEvent(GTZ_ENTER)
    testModalDisclosure.onOpen()
  }

  return (
    <>
      <Modal
        colorScheme={colorScheme}
        header={
          <DarkBox
            color={
              colorScheme === 'light'
                ? 'light.text.secondary'
                : 'text.secondary'
            }
            textStyle='caption'
          >
            {t('floors:tailgate_grid_modal_subtitle')}
          </DarkBox>
        }
        isOpen={isTailgateGridOpen}
        isSaveHidden
        onClose={handleClose}
        title={t('floors:tailgate_grid_modal_title')}
        zIndex={zIndex}
      >
        {/* The dark Modal body owns scrolling and its own themed scrollbar. */}
        <DarkBox data-testid='DarkTailgateGridModal:body'>
          <GridModalDetails colorScheme={colorScheme} />
          <GridModalBody
            colorScheme={colorScheme}
            onClose={handleClose}
            onOpenTestModal={handleOpenTestModal}
          />
        </DarkBox>
        {shouldRenderDummyPlayer && <DummyPlayer />}
      </Modal>
      <GridTestingZone
        colorScheme={colorScheme}
        isOpen={testModalDisclosure.isOpen}
        onClose={testModalDisclosure.onClose}
        zIndex={zIndex === undefined ? undefined : zIndex + 100}
      />
    </>
  )
}
